import { render, staticRenderFns } from "./ReturnMain.vue?vue&type=template&id=25585e0e&lang=pug&"
import script from "./ReturnMain.vue?vue&type=script&lang=js&"
export * from "./ReturnMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports